import React, { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';

/** Legger på .is-visible når elementet kommer inn i viewport. Kun opacity/transform. */
export function Reveal({ as: Tag = 'div', className, delay = 0, children, ...props }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            setVisible(true);
            io.disconnect();
          }
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={cn('reveal', delay ? `reveal-delay-${delay}` : '', visible && 'is-visible', className)} {...props}>
      {children}
    </Tag>
  );
}
